// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"18952":"cfbe2634742aa62f1f5d","25825":"9e1241336d2e720666fb","80020":"7a87020e23addf3280a7"}[chunkId] + ".css";
};